"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateAttributionMetrics = exports.attributionMetrics = void 0;
exports.attributionMetrics = {
    clicks: 'Clicks',
    cost: 'Cost',
    CPC: 'CPC',
    CPM: 'CPM',
    CTR: 'CTR',
    impressions: 'Impressions',
    visitors: 'Users',
    visits: 'Sessions',
};
const calculateAttributionMetrics = (attribution) => {
    return {
        clicks: Number(attribution.clicks),
        cost: Number(attribution.cost),
        CPC: Number(attribution.clicks) > 0 ? Number(attribution.cost) / Number(attribution.clicks) : 0,
        CPM: Number(attribution.impressions) > 0
            ? (Number(attribution.cost) * 1000) / Number(attribution.impressions)
            : 0,
        // in %
        CTR: Number(attribution.impressions) > 0
            ? (Number(attribution.clicks) * 100) / Number(attribution.impressions)
            : 0,
        impressions: Number(attribution.impressions),
        visitors: Number(attribution.visitors),
        visits: Number(attribution.visits),
    };
};
exports.calculateAttributionMetrics = calculateAttributionMetrics;
//# sourceMappingURL=attributionMetrics.js.map